import { useEffect } from "react";
import DataTable from "react-data-table-component";
import { useAFBRecurrentAdmin } from "./hooks/useAFBRecurrentAdmin";
import { customStylesCompany } from "../../../util/TableStyles";
import { noDataComponent } from "../../../util/DataObject";
import { Card, Skeleton, FlexGrid, Typography, useThemeProvider } from "@albo-ui/core";
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import CustomSearchBar from "../../elements/SearchBar/CustomSearchBar";
import CustomPagination from "../../elements/CustomPagination";
import AfbOperationManager from "../../modals/afb-company-admin/AfbOperationManager";

export const AfbRecurringOperation = ({changeAlert, changeLoader, sectionData, config, catalogs}: any) => {
    const { data, info, loading: loadingTable, columns, pagination, dialog, saveData, onHandleSearch, onHandleCreate, onHandleUpdate, onOpenDialog, onCloseDialog, onDisplayItem, changePage, handleChangeRowsPerPage } = useAFBRecurrentAdmin(changeAlert);
    const { theme } = useThemeProvider();

    useEffect(() => {
        saveData(sectionData, config);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        changeLoader(loadingTable);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);

    return (
        <>
            <Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: theme.colors.manatee}}>
                <FlexGrid container fullWidth justify="space-between" style={{ marginBottom: 25, display: "flex" }}>
                    {loadingTable ? (
                        <Skeleton width="100%" height="100px" style={{ marginTop: 20 }}/>
                    ) : (
                        <>
                            <FlexGrid item>
                                <Typography variant="h2" style={{display: "flex", alignItems: "center", fontSize: "1.4rem"}}>
                                    <ManageHistoryIcon sx={{ marginRight: 1 }} />Operaciones Recurrentes
                                </Typography>
                            </FlexGrid>
                            <FlexGrid item >
                                <CustomSearchBar
                                    field={true}
                                    onConfirm={onHandleSearch}
                                    textField={"Busqueda por uuid..."}
                                   button={{
                                        width: 150,
                                        text: "Crear",
                                        onHandle: onOpenDialog.bind(this, null)
                                    }}
                                />
                            </FlexGrid>
                        </>
                    )}
                </FlexGrid>


                <FlexGrid container style={{ margin: "25px 0" }} direction="column">
                    {loadingTable ? (
                        <Skeleton width="100%" height="100px" />
                    ) : (
                        <DataTable
                            data={data}
                            columns={columns}
                            expandableRows={true}
                            expandOnRowClicked={false}
                            expandableRowsComponent={onDisplayItem}
                            customStyles={customStylesCompany}
                            noDataComponent={noDataComponent}
                            highlightOnHover

                        />
                    )}
                </FlexGrid>
                <CustomPagination
                    rows={pagination.totalDocuments}
                    page={pagination.page}
                    rowsPerPage={pagination.rowsPerPage}
                    handleChangePage={changePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </Card>
            <AfbOperationManager
                data={info}
                open={dialog.open}
                onClose={onCloseDialog}
                changeAlert={changeAlert}
                changeLoader={changeLoader}
                onHandleExecute={info ? onHandleUpdate : onHandleCreate}
            />
        </>
    );
};
